import {Dialog, Icon, Layout, Ruler, Spacer, Text} from '@di-nxt/components';
import React, {useCallback, useState} from 'react';
import {SideBarButton} from '../../../components/sidebar/SideBarButton';
import {ModalProps, useSettings, useSettingsActions} from '../../../services';
import {AppearanceSelector} from './AppearanceSelector';
import {Appearance} from '../../../services/entities/local/settings/types';
import {t} from '../../../localization';
import {SettingsProps} from './types';

export const SettingsScreen: React.FC<ModalProps<SettingsProps, boolean>> = ({
  userId,
  firstname,
  lastname,
  callback,
}) => {
  const settings = useSettings(userId);

  const {update: updateSettings} = useSettingsActions();

  const handleCancel = useCallback(() => callback(false), [callback]);

  const [renderGeneral, setRenderGeneral] = useState(true);

  const handelGeneralSelected = useCallback(() => {
    setRenderGeneral(true);
  }, []);
  const handleNotificationSelected = useCallback(() => {
    setRenderGeneral(false);
  }, []);

  const handlechangeDarkmode = useCallback(
    (appearanceType: Appearance) => {
      updateSettings(userId, {appearance: appearanceType});
    },
    [updateSettings, userId],
  );

  return (
    <Dialog
      title={t('dialogs.settings.title')}
      okButtonDisabled
      okButtonTitle=""
      onOkButton={handleCancel}
      onCancelButton={handleCancel}
      hasCloseButton
      hideButtons
      size="Large">
      <Layout>
        <Layout vertical width={200}>
          <Spacer height={'10'} />
          <SideBarButton
            title={t('dialogs.settings.general.title')}
            selected={renderGeneral}
            onSelected={handelGeneralSelected}
          />
          <SideBarButton
            title={t('dialogs.settings.notifications.title')}
            selected={!renderGeneral}
            onSelected={handleNotificationSelected}
          />
        </Layout>
        <Ruler vertical width={'4'} />

        {renderGeneral ? (
          <Layout vertical paddingLeft={'40'} paddingTop="40">
            <Text variant={'inline_16_emphasis'}>Language</Text>
            <Spacer height={'20'} />
            <Layout>
              <Layout
                align="center"
                paddingLeft="10"
                borderColor={'border_mono_10'}
                borderStyle="solid"
                borderRadius="8"
                flex
                height={30}
                justify={'space-between'}>
                <Text variant="paragraph_14_default">English</Text>
                <Icon name="arrowDownSmall"></Icon>
              </Layout>
            </Layout>
            <Spacer height={'20'} />
            <Ruler horizontal width="1" />
            <Spacer height={'20'} />
            <Text variant={'inline_16_emphasis'}>Appearance</Text>
            <Spacer height={'20'} />
            <AppearanceSelector
              selected={settings?.appearance ? settings?.appearance : 'Auto'}
              onPress={handlechangeDarkmode}
              firstname={firstname}
              lastname={lastname}
            />
          </Layout>
        ) : null}
      </Layout>
    </Dialog>
  );
};
